/**
 * Paths used by `Viewing Pos Device` feature. Allows in example conditionally redirection.
 */
export const SALE_UNIT_CART_PATHS = ['table-detail'];
